import yup from './yup'
import { string } from 'yup'

export const representativeSchema = yup.object().shape({
  firstName: yup.string().label('First Name').trimmedRequired('First Name is required'),
  lastName: yup.string().label('Last Name').trimmedRequired('Last Name is required'),
  email: yup
    .string()
    .email('Email is not valid')
    .label('Email')
    .trimmedRequired('Email is required'),
  credential: string().label('Credential'),
  position: string().label('Position'),
  company: string().label('Organization'),
  country: string().label('Country'),
  state: string().label('State'),
  city: string().label('City'),
  phone: string().label('Phone'),
  isPrimaryContact: yup.boolean().label('Primary Contact')
})
